import React, { useState } from 'react';
import { ChevronDown, ChevronUp, MessageCircle, X } from 'lucide-react';
import { faqs } from '../mock/mockData';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFaq, setSelectedFaq] = useState(null);

  return (
    <>
      {/* Chat Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-red-600 hover:bg-red-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
      >
        {isOpen ? <X size={28} /> : <MessageCircle size={28} />}
      </button>

      {/* Chat Popup */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 z-50 w-96 bg-white rounded-lg shadow-2xl overflow-hidden border border-gray-200">
          <div className="bg-red-600 text-white p-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center">
                <MessageCircle className="text-red-600" size={24} />
              </div>
              <div>
                <h3 className="font-bold text-lg">Welcome to Support</h3>
                <p className="text-sm text-red-100">How can we help you?</p>
              </div>
            </div>
          </div>

          <div className="p-4 max-h-96 overflow-y-auto">
            <h4 className="font-bold text-gray-900 mb-4">FAQs</h4>
            <div className="space-y-2">
              {faqs.map((faq, index) => (
                <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
                  <button
                    onClick={() => setSelectedFaq(selectedFaq === index ? null : index)}
                    className="w-full p-3 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <span className="font-medium text-sm text-gray-900">{faq.question}</span>
                    {selectedFaq === index ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                  </button>
                  {selectedFaq === index && (
                    <div className="p-3 bg-gray-50 border-t border-gray-200">
                      <p className="text-sm text-gray-700">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;